module.exports = __webpack_public_path__ + "media/application/images/good-cyber-stories-41f954f62f4a1d36c65363ef3fbc5345.png";